import React from 'react';
import styled from 'styled-components';
import { InputRadioGroup, Text } from '@companycam/slab-web';
import { ANNUAL, MONTHLY } from '../Constants';
import { translate } from 'javascripts/translations/i18n';

type SubscriptionCycleInputProps = {
  handleOnChange: (arg: string) => void;
  selectedSubscriptionCycle: string;
};

const SubscriptionCycleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const StyledInputRadioGroup = styled(InputRadioGroup)`
  width: 100%;
  margin-bottom: var(--cc_size_spacing_l);

  fieldset {
    display: flex;
    > div {
      width: 100%;
      > div {
        flex-wrap: nowrap;
      }
    }
  }

  label {
    width: 100%;
    padding: var(--cc_size_spacing_l);
    padding-bottom: var(--cc_size_spacing_m);
    > span:nth-child(1)::after {
      background-color: var(--cc_color_border_input_active);
    }

    > span:nth-child(2) {
      transform: translateY(-5px);
    }
  }
`;

const labelStyle = {
  width: '50%',
  height: '90px',
  backgroundColor: 'var(--cc_color_background_1)',
  border: '1px solid var(--cc_color_border_default)',
  borderRadius: 'var(--cc_size_border_radius_l)',
};

const selectedLabelStyle = {
  width: '50%',
  height: '90px',
  backgroundColor: 'var(--cc_color_background_1)',
  border: '2px solid var(--cc_color_border_input_active)',
  borderRadius: 'var(--cc_size_border_radius_l)',
};

const SubscriptionCycleInput = ({
  handleOnChange,
  selectedSubscriptionCycle,
}: SubscriptionCycleInputProps) => {
  return (
    <StyledInputRadioGroup
      label=""
      selectedValue={selectedSubscriptionCycle}
      id="selected-subscription-cycle"
      layout="inline"
      options={[
        {
          label: (
            <SubscriptionCycleContainer data-testid="addPaymentModal__yearly">
              <Text as="p" family="heading" size="m" weight={600}>
                {translate('billing.subscriptionCycle.annualOption')}
              </Text>
            </SubscriptionCycleContainer>
          ),
          style:
            selectedSubscriptionCycle === ANNUAL
              ? selectedLabelStyle
              : labelStyle,
          value: ANNUAL,
        },
        {
          label: (
            <SubscriptionCycleContainer data-testid="addPaymentModal__monthly">
              <Text as="p" family="heading" size="m" weight={600}>
                {translate('billing.subscriptionCycle.monthlyOption')}
              </Text>
            </SubscriptionCycleContainer>
          ),
          style:
            selectedSubscriptionCycle === ANNUAL
              ? labelStyle
              : selectedLabelStyle,
          value: MONTHLY,
        },
      ]}
      onChange={(e) => handleOnChange(e.target.value)}
    />
  );
};

export default SubscriptionCycleInput;
